<template>
  <div class="wrapper">
    <!--loading动画-->
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;left:0;background:#000000;z-index:10000;opacity:0.8;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <img src="/static/images/loading.gif" width="150" />
      </div>
    </div>

    <div class="search-header">
      <div class="search-header-text">融资信息</div>
    </div>
    <div class="company-details-box dhy-box">
        <ul class="one-row-box">
        <li>
          <p class="date">证券简称</p>
          <p class="time">{{ articleInfo.company.shortname | nullVal }} </p>
        </li>
        <li>
          <p class="date">证券代码</p>
          <p class="time">{{ articleInfo.companycode | nullVal }} </p>
        </li>
        <li>
          <p class="date">融资人</p>
          <p class="time">{{ articleInfo.name_of_shareholder | nullVal }}</p>
        </li>
        <li>
          <p class="date">融资期限</p>
          <p class="time">
            {{ articleInfo.timelimit }}
            <template v-if="articleInfo.timelimit_unit == '月'">个{{ articleInfo.timelimit_unit }}</template>
            <template v-if="articleInfo.timelimit_unit == '年'">{{ articleInfo.timelimit_unit }}</template>
          </p>
        </li>
        <li>
          <p class="date"> 股份性质 </p>
          <p class="time"> {{ articleInfo.nature | nullVal }} </p>
        </li>
        <li v-if="articleInfo.nature == '限售'">
          <p class="date"> 限售解禁期</p>
          <p class="time"> {{ articleInfo.restriction_end_date | nullVal }} </p>
        </li>
        <li>
          <p class="date"> 股价（元）</p>
          <p class="time"> {{ articleInfo.stockprice | nullVal }} </p>
        </li>
        <li>
          <p class="date"> 质押率（%）</p>
          <p class="time"> {{ articleInfo.pledgee_ratio | nullVal }} </p>
        </li>
        <li>
          <p class="date"> 质押股数（万股） </p>
          <p class="time"> {{ articleInfo.pledgee_nums | formatMoney | nullVal }} </p>
        </li>
        <li>
          <p class="date"> 融资金额（万）</p>
          <p class="time"> {{ articleInfo.financing_amount | formatMoney | nullVal}} </p>
        </li>
        <li>
          <p class="date"> 资金用途</p>
          <p class="time"> {{ articleInfo.use | nullVal }} </p>
        </li>
        <li>
          <p class="date"> 还款来源</p>
          <p class="time"> {{ articleInfo.repayment_source | nullVal }} </p>
        </li>
       <!--  <li>
          <p class="date"> 状态 </p>
          <p class="time"> {{ articleInfo.status | formatFStauts | nullVal }} </p>
        </li> -->
        <li>
          <p class="date"> 添加日期 </p>
          <p class="time"> {{ articleInfo.addtime | formatTime | nullVal }} </p>
        </li>
        <li>
          <p class="date"> 更新日期 </p>
          <p class="time"> {{ articleInfo.updtime | formatTime | nullVal }} </p>
        </li>
       </ul>
     </div>

    <!--微信绑定弹框-->
    <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
      <div class="binding-content">
        <a class="binding-logo"></a>
        <div class="binding-text">
          立即绑定IBDATA账号<br/>成为金融分析高手
        </div>
        <div class="binding-bot">
          <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
          <a class="binding-btn" @click="goBindPage('x')">立即绑定</a>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
    <!-- / 微信绑定弹框-->
  </div>
</template>

<script>
  import {apiUrl, alert} from '../helper'
  import $ from 'jquery'
  import userMix from '../common/userMix'
  import wxshareMix from '../common/wxshareMix'
  import searchMix from '../common/SearchMix'

  export default {
    name: 'FinanceDetail',
    mixins: [userMix, wxshareMix, searchMix],
    data () {
      return {
        name: '',
        id: {},
        articleInfo: {},
        addtime: '',
        uidUrl: ''
      }
    },
    route: {
      data ({ to }) {
         if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {           //2
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile('weixin')  //1
          }
        }
        if (this.currentuser) {
          this.id.id = to.query.id;
          this.uidUrl = to.query.uidUrl;
          //微信签名
          this.getwxsign();
          this.loading = true;
          $.ajax({
            url: apiUrl('/V1.0.0/pledge/financingdetail'),
            method: 'post',
            data: JSON.stringify(this.id),
            dataType: 'json'
          }).done((response) => {
            this.loading = false;
            if (response.status === 0) {
              this.articleInfo = response.data
              this.changeMetaTitle(response.data.company.shortname);

              let updtime = response.data.updtime.split('T')[0];
              let financing_amount = this.formatMoney(response.data.financing_amount);
              console.log('financeing_amount')
              console.log(financing_amount)
              let title = '融资需求：' + response.data.company.shortname + '（' + updtime + '）';
              let desc = '融资金额：' + financing_amount + '(万)';
              // 标题： 更新 + 事件
              // 描述： 融资需求——证券简称
              this.shareFinanceDetail(title, desc);  //微信分享
            } else {
              console.log(response.description)
            }
          }).fail((response) => {
            this.loading = false;
            alert('请求失败')
            console.log(response.status)
          })
        }
      }
    },
    methods: {
      changeMetaTitle (title) {
        document.title = title
      },
      formatMoney(num) {
        num = num / 10000;
        if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(num)) {
            return num;
        }
        var a = RegExp.$1, b = RegExp.$2, c = RegExp.$3;
        var re = new RegExp("(\\d)(\\d{3})(,|$)");
        while (re.test(b))   b = b.replace(re, "$1,$2$3");

        return a + "" + b + "" + c;
      },
    },
    filters: {
      // 格式化money
      formatMoney(num) {
        num = num / 10000;
        if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(num)) {
            return num;
        }
        var a = RegExp.$1, b = RegExp.$2, c = RegExp.$3;
        var re = new RegExp("(\\d)(\\d{3})(,|$)");
        while (re.test(b))   b = b.replace(re, "$1,$2$3");
        return a + "" + b + "" + c;
      },
      //格式化日期
      formatTime(time) {
        if (!time) { return }
        if (time.indexOf('T') > 0) {
          return time.split('T')[0];
        } else {
          return time;
        }
      },
      nullVal: function (value) {
        if (!value) {
          return '--'
        } else {
          return value;
        }
      },
      formatFStauts: function(param) {
        if (param === '0' || param === 0) {
          return '新增';
        } else if (param == '1') {
          return '已完成';
        } else if (param == '9') {
          return '删除';
        } else if (param == 'ALL') {
          return '全部';
        } else {
          return param;
        }
      },
    }
  }
</script>

<style scoped>
  @import "../../static/css/article.css";

  .ar-detail p {
    font-size: 14px;
    line-height: 28px;
    color: #383838;
  }

  .ar-detail .blue {
    color: #3270ad !important;
  }
  div#dialog {
    display: block;
  }
</style>



/** WEBPACK FOOTER **
 ** finance.vue?db722ec8
 **/